import defaultClient from '@/plugins/axios/defaultClient'

export default {
  patchStore({ uuid, store }) {
    return defaultClient.patch(`/stores/${uuid}/`, store)
  },
}
